import { defineStore } from 'pinia'

export const useCompanyStore = defineStore('company', {
  state: () => {
    return {
      companyName: '',
      site: '',
      type: '1', // 1 – баланс, 2 – абонентская
      hourlyRate: 3500,
      hours: 0,
      errorMessage: '',
      sysObject: {},
      requisite: {
        inn: '',
        kpp: '',
        name: '',
      },
      settings: {
        rateType: '1', // Отображать только деньги, только оценку, и то и другое
        currency: 'RUB', // Валюта
        lang: 'ru', // Язык интерфейса
      }
    }
  },
  actions: {
    setCompany(company) {
      this.companyName = company.companyName
      this.site = company.site
      this.hourlyRate = company.hourlyRate
      this.requisite = company.requisite
      this.settings = company.settings
    },
    setSysObject(ob) {
      this.sysObject = ob
    },
    setErrorMessage(message) {
      this.errorMessage = message
    }
  },
})
